import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { Plugin } from '@nuxt/types'
import { defaultLanguage } from '~/utils/translationService'

Vue.use(VueI18n)

const i18nPlugin: Plugin = ({ app }) => {
  const showTranslationKey =
    // eslint-disable-next-line dot-notation
    app.$shopConfig?.cookies?.['hello_translations'] === '1'

  const i18nOptions: any = {
    fallbackLocale: defaultLanguage,
    locale: defaultLanguage,
    missing: (_: unknown, key: string, componentProxy: any) => {
      if (process.server && app.$env?.translationLoggingEnabled === '1') {
        componentProxy?.$logger.warn(`i18n - missing translations: ${key}`, {
          key,
          shopId:
            componentProxy.$shopConfig && componentProxy.$shopConfig.shopId,
        })
      }
    },
    silentFallbackWarn: true,
    silentTranslationWarn: true,
    ...(showTranslationKey
      ? {
          postTranslation: (str: string, key: string) => key || str,
        }
      : {}),
  }

  app.i18n = new VueI18n(i18nOptions)
}

export default i18nPlugin
